import { Exercise } from "../../../../models/Exercise";
import { useLocation } from "react-router";
import qs from "qs";
import getObjectIds from "../../../../../utils/getObjectIds";

interface ExerciseManagerHook {
  exerciseIds: string;
  exerciseName: string;
  exerciseDate: string;
  exercise: Exercise;
}

export default function useExerciseManager(): ExerciseManagerHook {
  const location = useLocation();
  const exerciseIds = qs.parse(location.search.slice(1)).exerciseIds as string;
  const exerciseName = qs.parse(location.search.slice(1)).exerciseName as string;
  const exerciseDate = qs.parse(location.search.slice(1)).exerciseDate as string;


  
  const exercise = {
    ...getObjectIds(exerciseIds),
    name: exerciseName,
  } as Exercise;

  return {
    exerciseIds,
    exerciseName,
    exerciseDate,
    exercise,
  };
}
